import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { IAuditableModel } from 'src/core/interfaces/auditableModel';
import { TableColumn } from 'src/@vex/interfaces/table-column.interface';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { MatTableDataSource } from '@angular/material/table';
import { CustomersListComponent } from '../../../shared-components/customers-list/customers-list.component';
import { ISalesQuotation } from 'src/core/interfaces/ISalesQuotation';
import { CurrencyPipe, DatePipe, DecimalPipe, Location } from '@angular/common';
import { FactoryService } from 'src/app/shared/services/factory.service';
import { IFactory } from 'src/core/interfaces/factory';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  UntypedFormControl,
  Validators
} from '@angular/forms';
import { forkJoin, map, Observable, startWith, Subject, takeUntil, tap } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ICustomer } from 'src/core/interfaces/customer';
import { ISalesQuotationLine } from 'src/core/interfaces/ISalesQuotationLine';
import { ActivatedRoute, Router } from '@angular/router';
import { SalesQuotationService } from 'src/app/shared/services/sales-quotation.service';
import { de, tr } from 'date-fns/locale';
import { ProductsListComponent } from '../../../shared-components/products-list/products-list.component';
import { IProduct } from 'src/core/interfaces/product';
import { ProductsService } from 'src/app/shared/services/products.service';
import { UserService } from 'src/app/shared/services/user.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SalesQuotationStatus } from 'src/assets/static-data/enums/sales-quotation-status.enum';
import { User } from 'src/core/interfaces/user';
import Swal from 'sweetalert2';
import { TransactionsInternalServicesService } from '../../../../../../../../../src/app/shared/services/transactions-internal-services.service';
import { PageLoadingService } from 'src/app/shared/services/page-loading.service';
import { valid } from 'chroma-js';
import { environment } from 'src/environments/environment';
import { ICustomerAddress } from 'src/core/interfaces/customerAddress';
import { add } from 'lodash';
import { SalesQuotationCheckBoxes } from 'src/assets/static-data/SalesQuotationCheckBoxes';
import { SalesQuotationPdfComponent } from 'src/app/shared/modules/print-templates/sales-quotation-pdf/sales-quotation-pdf.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// export interface IAttachmentsSalesQuotation extends IAuditableModel {
//   filename: string;
//   AttachedBy: string;
//   DateAndTime: string;
// }

@Component({
  selector: 'app-create-update-sales-quotation',
  templateUrl: './create-update-sales-quotation.component.html',
  styleUrl: './create-update-sales-quotation.component.scss',
  providers: [DatePipe,CurrencyPipe,DecimalPipe] // Provide DatePipe
})
export class CreateUpdateSalesQuotationComponent {
  //dataSource=new MatTableDataSource<ISalesQuotationLine>([]);
  apiUrl=environment.apiURL;
  columns: TableColumn<ISalesQuotationLine>[] = [
    {
      label: '#',
      property: 'index',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('PRODUCT_CODE'),
      property: 'itemCode',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('PRODUCT_NAME'),
      property: 'itemName',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('QUANTITY'),
      property: 'quantity',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('UNIT'),
      property: 'uom',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('UNIT_PRICE'),
      property: 'unitPrice',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('VAT')+'%',
      property: 'vatPercentage',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('TOTAL_BEFORE_VAT'),
      property: 'totalBeforeVAT',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('VAT_AMOUNT'),
      property: 'vatAmount',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('TOTALS'),
      property: 'total',
      type: 'text',
      visible: true
    },
    {
      label: '',
      property: 'actions',
      type: 'button',
      visible: true
    }
  ];;
  //attachmentsDataSource: MatTableDataSource<IAttachmentsSalesQuotation> | null;
  attachmentsColumns: TableColumn<any>[] = [
    {
      label: '#',
      property: 'index',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('ATTACHMENT'),
      property: 'filename',
      type: 'text',
      visible: true
    },
    {
      label: '',
      property: 'download',
      type: 'button',
      visible: true
    },
    {
      label: this.translateService.instant('ATTACHED_BY'),
      property: 'attachedBy',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('DATE_AND_TIME'),
      property: 'dateAndTime',
      type: 'text',
      visible: true
    },
    {
      label: '',
      property: 'actions',
      type: 'button',
      visible: true
    }
  ];
  currentPageAttachments = 0;
  isQuotationDetails: boolean = true;
  isAttachments: boolean = false;
  allCustomers: any;
  FactoryProducts: any;
  //dateOfToday: Date = new Date();
  factoriesList: IFactory[] = [];
  stateCtrl = new UntypedFormControl('');
  stateCtrl2 = new UntypedFormControl('');
  addressList: ICustomerAddress[] = [];
  stateCtrl3 = new UntypedFormControl();
  //addressList$:Observable<ICustomerAddress[]>;

  salesQuotationForm: FormGroup;
  filteredFactories$: Observable<IFactory[]>; // Filtered list of factories
  salesMenList$: Observable<User[]>;
  salesMenList: User[] = [];
  mode: 'create' | 'update' | 'copy' |'view' = 'create';
  downloadLink: any;
  SalesQuotationStatus = SalesQuotationStatus; // Expose the enum to the template
  submitted:boolean=false;
  isRtl:boolean=false;
  isLoading:boolean=true;
  htmlContent: SafeHtml = '';
    pdf: string = '';
  private destroy$ = new Subject<void>();
  salesQuotationCheckBoxes=SalesQuotationCheckBoxes;
  //isArabicLanguage:boolean=false;
  @ViewChild('hiddenReport', { static: false }) hiddenReport: SalesQuotationPdfComponent | undefined;

  constructor(
    private translateService: TranslateService,
    private dialog: MatDialog,
    private customerService: CustomerService,
    private location: Location,
    private factoryService: FactoryService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private salesQuotationService: SalesQuotationService,
    private productsService: ProductsService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private salesQuotationInternalService:TransactionsInternalServicesService,
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe,
    private sanitizer: DomSanitizer
  ) {
    this.salesQuotationForm = this.fb.group({
      id: [0],
      transactionNumber: [{ value: null, disabled: true }],
      customerCode: [{ value: null, disabled: false }, Validators.required],
      customerName: [{ value: null, disabled: true }, Validators.required],
      customerId: [null, Validators.required],
      factoryId: [null, Validators.required],
      transactionDate: [
        {
          value: new Date(),
          disabled: false,
        },
        Validators.required
      ],
      status: [{ value: null, disabled: true }, Validators.required],
      salesManId: [{ value: this.authService.isSalesAgentValue?this.authService.currentUserValue?.id:null, disabled: true }, Validators.required],
      vatPercentage: [{ value: 0, disabled: true }, Validators.required],
      vatAmount: [{ value: 0, disabled: true }, Validators.required],
      totalBeforeVAT: [{ value: 0, disabled: true }, Validators.required],
      total: [{ value: 0, disabled: true }, Validators.required],
      customerNote:[null],
      custCurrentBalance: [
        { value: null, disabled: true },
        Validators.required
      ],
      custCreditLimit: [{ value: null, disabled: true }, Validators.required],
      parentSalesQuotationId:[null],
      salesQuotationLines: this.fb.array([]),
      documentAttachments: this.fb.array([]),
      fromFactory:[false],
      customerAddressList:this.fb.array([]),
      notes:[null],
      validationCheckBoxes:this.fb.array(
        this.salesQuotationCheckBoxes.map(() => false) // Initialize checkboxes as unchecked
      ),
    });

  }

  //isLoading$=this.loadingService.isLoading$;

  ngOnInit() {
    //// // debugger;
//this.loadingService.setLoading(false);
this.isRtl=localStorage.getItem('lang')=='ar'|| localStorage.getItem('lang')=="ur"?true:false;
    //this.isRtl=this.translateService.currentLang=='ar'?true:false;
    const id = this.route.snapshot.paramMap.get('id');
    this.getAllDropDownLists().pipe(takeUntil(this.destroy$)).subscribe((res) => {
      
      //// // debugger;
      // Set salesman to current user if the user is a sales agent
      if (this.authService.isSalesAgentValue) {
        const currentSalesman = this.salesMenList.find(
          (salesMan) => salesMan.id === this.authService.currentUserValue?.id
        );
        if (currentSalesman) {
          // Set the autocomplete control and patch the underlying form value
          this.stateCtrl2.setValue(currentSalesman);
          this.salesQuotationForm.patchValue({ salesManId: currentSalesman.id });
          this.stateCtrl2.disable();
        }
      }
      
      if (id == null) {
        this.mode = 'create';
        this.generateEmptyRows(2);
        //this.loadingService.setLoading(false);
        
      } else {
        // Check if the route contains 'edit' or 'copy'

        //this.loadingService.setLoading(true);
        const currentRoute = this.route.snapshot.url
          .map((segment) => segment.path)
          .join('/');
        //// // debugger;

        if (currentRoute.includes('edit')) {
          this.mode = 'update';
        }
          else if(currentRoute.includes('view')){

          this.mode='view';

        } else {
          this.mode = 'copy';
          this.salesQuotationForm.get('customerCode').disable();
        }
        this.salesQuotationService
          .getSalesQuotationById(+id).pipe(takeUntil(this.destroy$))
          .subscribe((res) => {
            //// // debugger;
            this.customerService.getCustomerById(res.data.customerId).pipe(takeUntil(this.destroy$)).subscribe(customer=>{
             // // debugger;
              this.addressList=customer.data.customerAddresses;
           
            if (this.mode == 'update') {
              res.data.status != 0
                ? this.salesQuotationForm.get('customerCode').disable()
                : null;
            }
            this.salesQuotationForm.patchValue({
              id: res.data.id,
              transactionNumber: res.data.transactionNumber,
              customerCode: res.data.customerCode,
              customerName: res.data.customerName,
              customerId: res.data.customerId,
              factoryId: res.data.factoryId,
              transactionDate:res.data.transactionDate || '',
              status: this.salesQuotationInternalService.getStatusKeyFromValue(res.data.status,0),
              salesManId: res.data.salesManId,
              vatPercentage: res.data.vatPercentage,
              vatAmount: parseFloat(res.data.vatAmount.toFixed(4)),
              totalBeforeVAT: parseFloat(res.data.totalBeforeVAT.toFixed(4)),
              total: parseFloat(res.data.total.toFixed(4)),
              custCurrentBalance: res.data.customerCurrentBalance,
              custCreditLimit: res.data.customerCreditLimit,
              parentSalesQuotationId: res.data.parentSalesQuotationId,
              customerNote:res.data.customerNote,
              notes:res.data.notes,
              fromFactory:res.data.isFactoryDelivery
              //salesQuotationLines: res.data.salesQuotationLines,
              //documentAttachments:res.data.documentAttachments
            });
res.data.customerAddresses.forEach((address:any,index:number)=>{
  const addressGroup=this.fb.group({
    id:[address.id]
  })

  this.selectedAddresses.push(addressGroup);
})
            //// // debugger;
            res.data.documentAttachments.forEach((attachment: any,index: number) => {
              const attachmentGroup = this.fb.group({
                id:[attachment.id],
                filename: [attachment.filename, Validators.required],
                attachedBy: [
                  attachment.updatedBy
                    ? attachment.updatedBy
                    : attachment.createdBy,
                  Validators.required
                ],
                dateAndTime: [ this.datePipe.transform( attachment.updatedAt
                  ? attachment.updatedAt
                  : attachment.createdAt, 'yyyy-MM-dd HH:mm:ss') || ''
                 ,
                  Validators.required
                ],
                path: [attachment.path, Validators.required],
                fileContent: [attachment.path, Validators.required]
              });
              
              // Push each attachment group to the FormArray
              this.documentAttachments.push(attachmentGroup);

              
              if(this.mode=='view'){
                //// // debugger;
                this.documentAttachments.at(index).disable();
              }
              if(this.mode=='update'){
                //// // debugger;
                this.documentAttachments.at(index).get('attachedBy').disable();
                this.documentAttachments.at(index).get('dateAndTime').disable();
              }

              this.documentAttachments.controls = [
                ...this.documentAttachments.controls
              ];
            });

            res.data.salesQuotationLines.forEach(
              (lines: any, index: number) => {
                const quotationLines = this.fb.group({
                  id: [lines.id],
                  unitPriceWithTax: [0],
                  itemCode: [lines.itemCode, Validators.required],
                  itemName: [lines.itemName, Validators.required],
                  itemId: [lines.itemId, Validators.required],
                  quantity: [lines.quantity, Validators.required],
                  uom: [lines.uom, Validators.required],
                  unitPrice: [lines.unitPrice, Validators.required],
                  total: [parseFloat(lines.total.toFixed(4)), Validators.required],
                  vatPercentage: [lines.vatPercentage, Validators.required],
                  vatAmount: [parseFloat(lines.vatAmount.toFixed(4)), Validators.required],
                  totalBeforeVAT: [parseFloat(lines.totalBeforeVat.toFixed(4)), Validators.required],
                });

                
                // Push each attachment group to the FormArray
                this.salesQuotationLines.push(quotationLines);

                

                this.lineInputChanges(index, 'quantity');

                if(this.mode=='view'){
                  this.salesQuotationLines.at(index).disable();
                }

                if(this.mode=='update'){
                  this.salesQuotationLines.at(index).get('itemName').disable();
                  this.salesQuotationLines.at(index).get('uom').disable();
                  this.salesQuotationLines.at(index).get('vatPercentage').disable();
                  this.salesQuotationLines.at(index).get('vatAmount').disable();
                  this.salesQuotationLines.at(index).get('totalBeforeVAT').disable();
                  this.salesQuotationLines.at(index).get('total').disable();
                }

                this.salesQuotationLines.controls = [
                  ...this.salesQuotationLines.controls
                ];

                this.changeSalesQuotationLinesNumbersCurrency(index,'unitPrice');
                this.changeSalesQuotationLinesNumbersCurrency(index,'total');
                this.changeSalesQuotationLinesNumbersCurrency(index,'vatAmount');
                this.changeSalesQuotationLinesNumbersCurrency(index,'totalBeforeVAT');

                this.changeSalesQuotationLinesNumbers(index,'quantity');

              }
            );

            res.data.priceInfoList?.forEach((priceBoolean:any,index:number)=>{
              // // debugger;
              this.validationCheckBoxes.at(index).setValue(priceBoolean=="true"?true:false);
            })
            //this.stateCtrl.setValue(res.data.factoryId?`${res.data.factoryCode} - ${res.data.factoryName}`:'');
            this.displayFactory(
              this.factoriesList.find(
                (factory) => factory.id === res.data.factoryId
              )
            );
            this.stateCtrl.setValue(
              this.factoriesList.find(
                (factory) => factory.id === res.data.factoryId
              )
            );

            //// // debugger;
            this.displaySalesMan(
              this.salesMenList.find(
                (salesMan) => salesMan.id === res.data.salesManId
              )
            );

            const value=this.salesMenList.find(
              (salesMan) => salesMan.id === res.data.salesManId
            )
            this.stateCtrl2.setValue(
              value
            ),{eventEmit:true};

            if(this.mode=='copy'){
              this.salesQuotationForm.patchValue({
                parentSalesQuotationId: res.data.id,
                id:0,
                customerNote:null,
                status: null,
              });
            }
            else if(this.mode=='view'){
              this.salesQuotationForm.disable();
              this.stateCtrl.disable();
              this.stateCtrl2.disable();
              this.stateCtrl3.disable();
            }
          
          
            //this.loadingService.setLoading(false);
            //this.cdRef.detectChanges();

          });
        });
          this.isLoading=false;
      }
    });

    // Filter factories based on user input
    this.filteredFactories$ = this.stateCtrl.valueChanges.pipe(
      startWith(''),
      map((value) =>
        typeof value === 'string' ? value : value ? value.name : ''
      ),
      map((name) =>
        {if(name){ return this._filterList(name, 0) }else{ this.salesQuotationForm.get('factoryId').reset(); return this.factoriesList.slice()}}
      ),
      tap(() => this.salesQuotationForm.get('factoryId').markAsTouched())
    );

    this.salesMenList$ = this.stateCtrl2.valueChanges.pipe(
      startWith(''),
      map((value) => (value === 'string' ? value : value ? value.userName : '')),
      map((name) => 
        {  
          if(name){ return this._filterList(name, 1)}else{ this.salesQuotationForm.get('salesManId').reset(); return this.salesMenList.slice()}}),
      tap(() => this.salesQuotationForm.get('salesManId').markAsTouched()) // Mark as touched here
    );

    this.salesQuotationForm.get('fromFactory').valueChanges.subscribe((value) => {
      if (value) {
        this.stateCtrl3.setValue(null);
        this.selectedAddresses.clear();
        this.selectedAddresses.setErrors(null);
      }
      else{
        this.selectedAddresses.setErrors({required:true})
      }
    });
    // this.addressList$ = this.stateCtrl3.valueChanges.pipe(
    //   startWith(''),
    //   map((value) => (value === 'string' ? value : value ? value.name : '')),
    //   map((name) =>
    //     {// // debugger;
    //       {return this.addressList.slice()}}),
    //   tap(() => this.salesQuotationForm.get('customerAddressList').markAsTouched())); // Mark as touched here

    this.customerService.getAllCustomers().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.allCustomers = data?.data;
    });

    // this.productsService.getProducts().pipe(takeUntil(this.destroy$)).subscribe((data) => {
    //   this.FactoryProducts = data?.data;
    // });  
    
  }

  ngOnDestroy() {
    // Emit destroy signal to unsubscribe all
    this.destroy$.next();
    this.destroy$.complete();
  }
  
  get salesQuotationLines(): FormArray {
    return this.salesQuotationForm.get('salesQuotationLines') as FormArray;
  }
  get documentAttachments(): FormArray {
    return this.salesQuotationForm.get('documentAttachments') as FormArray;
  }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }

  get visibleColumnsAttachments() {
    return this.attachmentsColumns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }

  trackByProperty<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }

  trackByPropertyAttachments<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }

  get validationCheckBoxes(): FormArray {
    return this.salesQuotationForm.get('validationCheckBoxes') as FormArray;
  }

  //0:quootation details, 1:attachments
  createEmptyRow(mode: number): FormGroup {
    //// // debugger;
    let row = null;
    if (mode == 0) {
      row = this.fb.group({
        id: [0],
        itemCode: [{ value: '', disabled: true }, Validators.required],
        itemId: [null, Validators.required],
        itemName: [{ value: '', disabled: true }, Validators.required],
        quantity: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(0)]
        ],
        uom: [{ value: '', disabled: true }, Validators.required],
        unitPrice: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(0)]
        ],
        unitPriceWithTax: [0],
        total: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(0)]
        ],
        vatPercentage: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(0)]
        ],
        totalBeforeVAT: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(0)]
        ],
        vatAmount: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(0)]
        ]
      });
    } else {
      row = this.fb.group({
        id:[0],
        filename: [{ value: '', disabled: true }, Validators.required],
        attachedBy: [{ value: '', disabled: true }, Validators.required],
        dateAndTime: [{ value: null, disabled: true }, [Validators.required]],
        path: [null,Validators.required],
        fileContent: [{ value: null, disabled: true }, Validators.required]
      });
    }
    row.updateValueAndValidity(); // Force validation to trigger immediately
    return row;
  }

  //initial generation
  generateEmptyRows(count: number) {
    //// // debugger;

    const rows = this.salesQuotationForm.get(
      'salesQuotationLines'
    ) as FormArray;
    for (let i = 0; i < count; i++) {
      rows.push(this.createEmptyRow(0));
      //this.checkAndEnableNextRow(i)
    }

    const rowsAttach = this.salesQuotationForm.get(
      'documentAttachments'
    ) as FormArray;
    for (let i = 0; i < count; i++) {
      rowsAttach.push(this.createEmptyRow(1));
      //this.checkAndEnableNextRow(i);
    }

    //enable first row only
    this.enableRow(0);

    this.salesQuotationLines.controls = [...this.salesQuotationLines.controls];
    this.documentAttachments.controls = [...this.documentAttachments.controls];

    this.isLoading=false;
  }
  addItem(): void {
    //// // debugger;

    if (this.isQuotationDetails) {
      const newRow = this.createEmptyRow(0);

      this.salesQuotationLines.push(newRow); // Add the new FormGroup to the FormArray
      this.salesQuotationLines.updateValueAndValidity();
      this.salesQuotationLines.controls = [
        ...this.salesQuotationLines.controls
      ];
      // Enable the new row if the previous row is valid
      if (this.salesQuotationLines.length > 1) {
        this.checkAndEnableNextRow(this.salesQuotationLines.length - 2);
      }
    } else {
      //// // debugger;
      const newRow = this.createEmptyRow(1);

      this.documentAttachments.push(newRow); // Add the new FormGroup to the FormArray
      this.documentAttachments.updateValueAndValidity();
      this.documentAttachments.controls = [
        ...this.documentAttachments.controls
      ];
      // Enable the new row if the previous row is valid
      if (this.documentAttachments.length > 1) {
        this.checkAndEnableNextRow(this.documentAttachments.length - 2);
      } else {
        this.enableRow(0);
      }
    }
  }


  changeSalesQuotationLinesNumbersCurrency(i:number,formControl:string){
    const value=this.salesQuotationLines.at(i).get(formControl).value;
    if (value !== null && typeof value === 'number') {
      const formatted = this.currencyPipe.transform(value, 'SAR', 'symbol', '1.0-4').replace('SAR', '') + ' SAR';
      this.salesQuotationLines.at(i).get(formControl).setValue(formatted, { emitEvent: false });
    }
  }

  changeSalesQuotationLinesNumbers(i:number,formControl:string){
    const value=this.salesQuotationLines.at(i).get(formControl).value;
    if (value !== null && typeof value === 'number') {
      const formatted = this.decimalPipe.transform(value, '1.0-4') || '';
      this.salesQuotationLines.at(i).get(formControl).setValue(formatted, { emitEvent: false });
    }
  }

  lineInputChanges(index: number, formControl?: string): void {
    //this.checkAndEnableNextRow(index);
    //// // debugger;
    if (
      ['quantity', 'vatPercentage', 'unitPrice'].includes(formControl)
    ) {
      this.salesQuotationLines.at(index).patchValue({
        unitPrice:this.getFormattedNumber(index,'unitPrice'),
      });
      this.salesQuotationLines.at(index).patchValue({
        quantity:this.getFormattedNumber(index,'quantity'),
      });
      this.salesQuotationLines.at(index).patchValue({
        totalBeforeVAT:this.getFormattedNumber(index,'unitPrice') * this.getFormattedNumber(index,'quantity'),
      });
      this.salesQuotationLines.at(index).patchValue({
        vatAmount:this.getFormattedNumber(index,'totalBeforeVAT') * (this.getFormattedNumber(index,'vatPercentage')/100),
      });
      this.salesQuotationLines.at(index).patchValue({
        total:this.getFormattedNumber(index,'totalBeforeVAT') + this.getFormattedNumber(index,'vatAmount'),
      });
      //////////////////////////////////////////////

      this.salesQuotationForm.get('totalBeforeVAT').patchValue(
        this.calculateColumnSum('totalBeforeVAT')
      );
      this.salesQuotationForm.get('vatAmount').patchValue(
        this.calculateColumnSum('vatAmount')
      );
      this.salesQuotationForm.get('total').patchValue(
        this.calculateColumnSum('total')
      );

      if (index == 0) {
        this.salesQuotationForm.get('vatPercentage').patchValue(
        this.salesQuotationLines.at(index).get('vatPercentage').value
        );
      }
    }

    if (
        ['filename'].includes(
          formControl
        )){
          this.documentAttachments.at(index).patchValue({
                  attachedBy: this.authService.currentUserValue.firstName,
                  dateAndTime: this.datePipe.transform(
                    this.datePipe.transform( new Date(), 'yyyy-MM-dd HH:mm:ss') || '',
                    'dd/MM/yyyy HH:mm:ss'
                  )
                });
        }
    this.documentAttachments.controls = [...this.documentAttachments.controls];
    this.salesQuotationLines.controls = [...this.salesQuotationLines.controls];
    this.checkAndEnableNextRow(index);
  }

  checkAndEnableNextRow(index: number): void {
    //// // debugger;
    if (this.isQuotationDetails) {
      if (
        this.salesQuotationLines.at(index).valid &&
        this.salesQuotationLines.at(index).enabled &&
        index < this.salesQuotationLines.length - 1
      ) {
        this.enableRow(index + 1); // Enable the next row if current row is valid
      }

      if (index == 0 && this.mode !=='view' ) {
        this.enableRow(0);
      }
    } else {
      if (
        this.documentAttachments.at(index).valid &&
        this.documentAttachments.at(index).enabled &&
        index < this.documentAttachments.length - 1
      ) {
        this.enableRow(index + 1); // Enable the next row if current row is valid
      }
      if (index == 0 && this.mode !=='view') {
        this.enableRow(0);
      }
    }
  }

  enableRow(index: number): void {
    //// // debugger;
    if (index === 0 && this.mode !=='view') {
      this.salesQuotationLines.at(index)?.get('itemCode').enable();
      this.salesQuotationLines.at(index)?.get('quantity').enable();
      this.salesQuotationLines.at(index)?.get('unitPrice').enable();
      this.documentAttachments.at(index)?.get('filename').enable();
    } else if (this.isQuotationDetails) {
      const control = this.salesQuotationLines.at(index);
      if (control) {
        control.get('itemCode').enable();
        control.get('quantity').enable();
        control.get('unitPrice').enable();// Enable the FormGroup at the specified index
      }
    } else {
      const control = this.documentAttachments.at(index);
      if (control) {
        control.get('filename').enable(); // Enable the FormGroup at the specified index
      }
    }
  }

  onDownloadClick(index: number): void {
    //// // debugger;
    const uploadedFile = this.documentAttachments
      .at(index)
      .get('path').value;
    
    let url: string;
  
    if (typeof uploadedFile === 'string') {
      // If uploadedFile is a string (file path), construct the URL to the file
      // Assuming the file is served via HTTP (make sure the file is publicly accessible)
      url = `${this.apiUrl}/${uploadedFile.replace(/\\/g, '/')}`;
      // Trigger the download
    const link = document.createElement('a');
    //link.href = url;
    link.download = uploadedFile.split('/').pop() || 'download'; // Use the last part of the path as the file name
    link.click(); // Simulate the click to trigger download
    } else {
      // If uploadedFile is a Blob object, create a blob URL
      url = URL.createObjectURL(uploadedFile);
    }
  
    
  
    // If the URL is a Blob URL, clean up after the download to free up memory
    if (typeof uploadedFile !== 'string') {
      this.downloadLink = url;
      //URL.revokeObjectURL(url);
    }
  }

  onFileChange(event, index: number): void {
    //// // debugger;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.documentAttachments.at(index).patchValue({
        filename: file.name,
        fileContent: file,
        path:file,
      });

      this.lineInputChanges(index, 'filename');

      // this.form.patchValue({
      //   license: file,
      // });
      // this.selectedFile = file ?? null;
      const fileType = file.type;

      // this.resetPreview();

      const reader = new FileReader();

      if (fileType.startsWith('text/')) {
        reader.onload = () => {
          // this.fileContent = reader.result as string;
          // this.isText = true;
        };
        reader.readAsText(file); // Correct method for text files
      } else {
        reader.onload = () => {
          const result = reader.result as string;

          // if (fileType.startsWith('image/')) {
          //   this.isImage = true;
          //   this.imagePreviewUrl = result;
          // } else if (fileType === 'application/pdf') {
          //   this.isPDF = true;
          //   this.pdfPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(result);
          // }
        };
        reader.readAsDataURL(file); // For images and PDFs
      }
    }
  }

  /////////////////////////////////////////////////////////////

  getFormattedNumber(index: number,formControl:string): number {
    const quantity = this.salesQuotationLines.at(index).get(formControl).value;
    // Remove non-numeric characters except for dot and minus sign
    const cleanedValue = quantity ? parseFloat(quantity.toString().replace(/[^\d.-]/g, '')) : 0;
    return isNaN(cleanedValue) ? 0 : cleanedValue; // Ensure a valid number is returned
  }


  openSearchCustomer() {
    this.dialog
      .open(CustomersListComponent, {
        data: {customersList:this.allCustomers,customerId:this.salesQuotationForm.get('customerId').value},
        width: '40%',
        maxHeight: '90%'
      })
      .afterClosed().pipe(takeUntil(this.destroy$))
      .subscribe((selectedCustomer: ICustomer) => {
        // // debugger;
        if (selectedCustomer) {
          this.salesQuotationForm.patchValue({
            customerCode: selectedCustomer.code,
            customerName: selectedCustomer.name,
            customerId: selectedCustomer.id,
            custCurrentBalance: selectedCustomer.currentAccountBalance,
            custCreditLimit: selectedCustomer.creditLimit,
            
            //salesManId: selectedCustomer.sapSalesPersonCode,
          });

          this.addressList=[];
          // Assuming 'selectedCustomer.customerAddresses' is an array of objects
          this.loadCustomerAddresses(selectedCustomer.id).subscribe({
            next: (response) => {
              this.addressList = response.data.customerAddresses;
                        //this.addressList = selectedCustomer.customerAddresses;
          //on choosing a customer delete any other customers
          this.stateCtrl3.setValue(null);
          this.selectedAddresses.clear();

          const salesManValue=this.salesMenList.find(
            (salesMan) => salesMan.sapSalesManCode == selectedCustomer.sapSalesPersonCode
          );

          if(selectedCustomer?.sapSalesPersonCode && salesManValue){
          this.displaySalesMan(
            salesManValue
          );
          this.stateCtrl2.setValue(
            salesManValue
          );

          this.salesQuotationForm.patchValue({
            salesManId: salesManValue?.id // Store factory ID in form control
          });
        } else{
          this.displaySalesMan(
            null
          );
          this.stateCtrl2.setValue(
            null
          );

          this.salesQuotationForm.patchValue({
            salesManId: null // Store factory ID in form control
          });
        }
            },
            error: (error) => {
              console.error('Error loading customer addresses:', error);
            }
          });

      }
      });
  }

  loadCustomerAddresses(customerId: number) {
    //// debugger
    return this.customerService
      .getCustomerById(customerId)
      .pipe(takeUntil(this.destroy$));
      
  }

  openSearchProducts(index: number) {
    // // debugger;
    this.dialog
      .open(ProductsListComponent, {
        data: {productsList:this.FactoryProducts,productId:this.salesQuotationLines.at(index).get('itemId').value},
        width: '40%',
        maxHeight: '90%'
      })
      .afterClosed().pipe(takeUntil(this.destroy$))
      .subscribe((selectedProduct: IProduct) => {
        //// // debugger;
        if (selectedProduct) {
          this.salesQuotationLines.at(index).patchValue({
            itemCode: selectedProduct.code,
            itemName: selectedProduct.name,
            itemId: selectedProduct.id,
            uom: selectedProduct.sapUoM,
            unitPrice: selectedProduct.price,
            vatPercentage: selectedProduct.salesVatPercentage,
            quantity: 1
          });
        }
        this.lineInputChanges(index, 'unitPrice');
      });
  }

  getDynamicWidth(index: number,formControl:string,placeholder?: string): string {
    let inputValue='';
  
    if(this.isQuotationDetails){
      inputValue = this.salesQuotationLines.at(index).get(formControl).value;
    }else{
       inputValue = this.documentAttachments.at(index).get(formControl).value;
    }
    // Adjust according to your form structure
    // Calculate lengths based on value and placeholder
    const inputLength = inputValue ? inputValue.toString().length : 0;
    const placeholderLength = placeholder ? placeholder.length : 0;

   // Use the longer of the two lengths for width calculation
    const length = Math.max(inputLength, placeholderLength);
    // Base width and multiplier
    const baseWidth = 60;  // Minimum width in pixels
    const widthAdjustment = length * 6.8; // Each character adds 6.5px (adjust based on your font size)

    // Returning width as a string with 'px' unit
    return `${baseWidth + widthAdjustment}px`;
  }
  onBack() {
    //// // debugger;
    this.salesQuotationForm.reset();
    this.location.back();
  }

  onSave(status: number) {
    // // debugger;
    this.submitted=true;

    if(this.salesQuotationForm.get('fromFactory').value==false && this.selectedAddresses.length==0){
      this.selectedAddresses.setErrors({ required: true });
      return;
    }
    else{
      this.selectedAddresses.setErrors(null);
    }
    let savedForm = this.salesQuotationInternalService.deepCopyFormGroup(this.salesQuotationForm) as FormGroup;
    // Set the status value
    if(status !=null){
    savedForm.get('status').setValue(status);
    }
    else{
      savedForm.get('status').setValue(SalesQuotationStatus[savedForm.get('status').value]);
    }
    
     (savedForm.get('salesQuotationLines') as FormArray).controls.forEach(
    (element,index) => {
    (element as FormGroup).setControl('unitPrice', new FormControl(this.getFormattedNumber(index,'unitPrice')));
    (element as FormGroup).setControl('total', new FormControl(this.getFormattedNumber(index,'total')));
    (element as FormGroup).setControl('vatAmount', new FormControl(this.getFormattedNumber(index,'vatAmount')));
    (element as FormGroup).setControl('totalBeforeVAT', new FormControl(this.getFormattedNumber(index,'totalBeforeVAT')));
    (element as FormGroup).setControl('quantity', new FormControl(this.getFormattedNumber(index,'quantity')));
  }
);
    // Filter valid controls in the 'salesQuotationLines' FormArray

    const validSalesQuotationLines = (
      savedForm.get('salesQuotationLines') as FormArray
    ).controls.filter((control) => control.valid);

    // If you need to keep only valid lines in savedForm, you can create a new FormArray
    const validSalesQuotationLinesArray = new FormArray(
      validSalesQuotationLines
    );

    const validDocumentAttachmentsLines = (
      savedForm.get('documentAttachments') as FormArray
    ).controls.filter((control) => control.valid);

    // If you need to keep only valid lines in savedForm, you can create a new FormArray
    const validDocumentAttachmentsLinesArray = new FormArray(
      validDocumentAttachmentsLines
    );
    // Optionally replace the original salesQuotationLines with the valid ones
    savedForm.setControl('salesQuotationLines', validSalesQuotationLinesArray);
    savedForm.setControl(
      'documentAttachments',
      validDocumentAttachmentsLinesArray
    );
    //savedForm.setControl('transactionDate', new FormControl(this.salesQuotationInternalService.transformDateFormat(savedForm.get('transactionDate').value)));

    if (savedForm.invalid) {
      Swal.fire({
        title: this.translateService.instant('FILL_REQUIRED_FIELDS.TEXT'),
        icon: 'warning',
        timer: 1000,  // The alert will disappear after 1000 milliseconds (1 second)
        showConfirmButton: false  // Optional: Hide the confirm button
      });
      return;
    } else {
      //console.log(savedForm.value);
      if (this.mode == 'create' || this.mode=='copy') {
        this.salesQuotationService
          .addNewSalesQuotation(savedForm.value).pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (res) => {
              Swal.fire({
                title: this.translateService.instant('SALESQUOTATION_CREATED_SUCCESSFULLY.TEXT'),
                icon: 'success',
                timer: 1000,  // The alert will disappear after 1000 milliseconds (1 second)
                showConfirmButton: false  // Optional: Hide the confirm button
              });
              
              this.router.navigate(['/transactions/sales-quotation']);
            },
            error: (err) => {
              console.log(err);

              Swal.fire({
                title: this.translateService.instant('SALESQUOTATION_CREATED_FAILED.TEXT'),
                icon: 'error',
                timer: 1000,  // The alert will disappear after 1000 milliseconds (1 second)
                showConfirmButton: false  // Optional: Hide the confirm button
              });
            }
          });
      }
      else if (this.mode == 'update') {
        this.salesQuotationService
          .updateSalesQuotation(savedForm.get('id').value, savedForm.value).pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (res) => {
              Swal.fire({
                title: this.translateService.instant('SALESQUOTATION_UPDATED_SUCCESSFULLY.TEXT'),
                icon: 'success',
                timer: 1000,  // The alert will disappear after 1000 milliseconds (1 second)
                showConfirmButton: false  // Optional: Hide the confirm button
              });
              this.router.navigate(['/transactions/sales-quotation']);
            },
            error: (err) => {
              //console.log(err);
              Swal.fire({
                title: this.translateService.instant('SALESQUOTATION_UPDATED_FAILED.TEXT'),
                icon: 'error',
                timer: 1000,  // The alert will disappear after 1000 milliseconds (1 second)
                showConfirmButton: false  // Optional: Hide the confirm button
              });
            }
          });
      }
      
    }
  }

  removeLine(i: number): void {
    //// // debugger;
    if (this.isQuotationDetails) {
      this.salesQuotationLines.removeAt(i);
      this.salesQuotationLines.updateValueAndValidity();
      this.salesQuotationLines.controls = [
        ...this.salesQuotationLines.controls
      ];
    } else {
      this.documentAttachments.removeAt(i);
      this.documentAttachments.updateValueAndValidity();
      this.documentAttachments.controls = [
        ...this.documentAttachments.controls
      ];
    }

    this.checkAndEnableNextRow(i + 1);
  }

  getAllDropDownLists() {
    return forkJoin({
      factories: this.factoryService.getFactories(),
      salesMen: this.userService.getSalesAgentUsersList(),
    }).pipe(
      tap(({ factories, salesMen }) => {
        // Set the data for each list
        //// // debugger;
        this.factoriesList = factories.data;
        this.salesMenList = salesMen.data;
      })
    );
  }

  // Display function for autocomplete
  displayFactory(factory: IFactory | null): string {
    //// // debugger;
    return factory ? `${factory.code} - ${factory.name}` : '';
  }

  displaySalesMan(salesMan: User | null): string {
    //// // debugger;
    return salesMan ? `${salesMan.userCode} - ${salesMan.userName}` : '';
  }

  displayAddress(address: ICustomerAddress | null): string {
    // debugger
    let displayedAddress = '';
  
    console.log('Selected Addresses:', this.selectedAddresses?.value);
    // Iterate over the selectedAddresses FormArray to gather selected addresses
    this.selectedAddresses?.controls.forEach(control => {
      const selectedAddress = this.addressList?.find(
        addr => addr.id === control.value.id
      );
      if (selectedAddress) {
        displayedAddress += selectedAddress.name + ', ';
      }
    });
  
    // Append the current address if it exists and is not already selected
    if (address && !this.selectedAddresses?.controls.some(control => control.value.id === address.id)) {
      displayedAddress += address.name;
    }
  
    // Remove trailing comma and space
    return displayedAddress.trim().replace(/,$/, '');
  }
  
  generatePdf(): void {
    this.salesQuotationInternalService.generatePdf(this.hiddenReport);
  }
  getQuotationPDF(id:number): void {
    this.salesQuotationService
      .printSalesQuotation(id).subscribe({
        next:(response) => {
          console.log('customer acc details', response.data);
          this.isLoading=false;
          //this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(response.data.htmlContent.replace("{logo_png_place_holder}", "/assets/img/logo_transparent.png"));
          this.pdf = response.data.pdfContent;
          this.downloadPDF(this.pdf, 'sales-quotation.pdf');
        },
        error:(error) => {
          console.error('Error fetching quotation:', error);
        }}
      );
  }

  downloadPDF(base64String: string, fileName: string) {
    const byteCharacters = atob(base64String);
    console.log(this.pdf); // First 50 chars
    console.log(base64String.substring(0, 50)); // First 50 chars
console.log(base64String.substring(base64String.length - 50)); // Last 50 chars

    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
  
    const blob = new Blob([byteArray], { type: 'application/pdf' });
  
    // Use an Object URL for large files
    const blobUrl = window.URL.createObjectURL(blob);
  
    fetch(blobUrl).then(response => response.blob()).then(blobData => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blobData);
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
  
      URL.revokeObjectURL(blobUrl);
    });
  }
  // displayAddress(address: ICustomerAddress | null): string {
  //   //// // debugger;
  //   return address ? `${address.name}` : '';
  // }

  get selectedAddresses(): FormArray {
    return this.salesQuotationForm.get('customerAddressList') as FormArray;
  }

  isAddressSelected(address: any): boolean {
    return this.selectedAddresses.controls.some(
      control => control.value.id === address.id
    );
  }

  toggleAddressSelection(address: any, isSelected: boolean): void {
    // // debugger;
    if (isSelected) {
      this.selectedAddresses.push(
        this.fb.group({
          id: [address.id]
        })
      );
    } else {
      const index = this.selectedAddresses.controls.findIndex(
        control => control.value.id === address.id
      );
      if (index !== -1) {
        this.selectedAddresses.removeAt(index);
      }
    }
  }

  getAddressName(addressId: number): string | undefined {
    return this.addressList?.find(address => address.id === addressId)?.name;
  }

  removeAddress(index: number): void {
    this.selectedAddresses.removeAt(index);
  }

  ondropDownSelected(event: any, index: number) {
    // // debugger;
    if (index == 0) {
      const selectedFactory = event.option.value as IFactory;
      this.salesQuotationForm.patchValue({
        factoryId: selectedFactory.id // Store factory ID in form control
      });
      this.productsService.getFactoryProducts(selectedFactory.id).subscribe((response) => {
        console.log(response.data)
        this.FactoryProducts = response.data;
      });
    } else if (index == 1) {
      const selectedSalesMan = event.option.value as User;
      this.salesQuotationForm.patchValue({
        salesManId: selectedSalesMan.id // Store factory ID in form control
      });
     }
    //else{
    //   const selectedAddress = event.option.value as ICustomerAddress;
    //   const addresses=this.salesQuotationForm.get('customerAddressList') as FormArray 
    //   addresses.push(
    //     this.fb.group({
    //       id: [selectedAddress.id]
    //     })
    //   )
    // }
  }

  toggleAction(quotationDetails:boolean){
    //// // debugger;    

    this.salesQuotationLines.controls.forEach((control,index)=>{
      this.changeSalesQuotationLinesNumbersCurrency(index,'unitPrice');
      this.changeSalesQuotationLinesNumbersCurrency(index,'total');
      this.changeSalesQuotationLinesNumbersCurrency(index,'vatAmount');
      this.changeSalesQuotationLinesNumbersCurrency(index,'totalBeforeVAT');
      this.changeSalesQuotationLinesNumbers(index,'quantity');
    })
    this.isQuotationDetails=quotationDetails;
    this.isAttachments=!quotationDetails;
  }

  // selectedAddressDisplay(): string {
  //   // // debugger;
  //   const selectedNames = this.selectedAddresses.controls.map(
  //     control => control.value.id
  //   );
  //   return selectedNames.join(', '); // Concatenate the names with commas
  // }
  private _filterList(name: string, index: number): any[] {
    // // debugger;
    //0->factories, 1->salesMen
    const filterValue = name.toLowerCase();
    if (index == 0) {
      return this.factoriesList.filter(
        (factory) =>
          factory.name.toLowerCase().includes(filterValue) ||
          factory.code?.toLowerCase().includes(name.toLowerCase())
      );
    } else if (index == 1) {
      return this.salesMenList.filter(
        (salesMan) =>
          salesMan.userName.toLowerCase().includes(filterValue) ||
          salesMan.userCode?.toLowerCase().includes(name.toLowerCase())
      );}
    //  else{
    //   return this.addressList.filter(
    //     (address) =>
    //       address.name.toLowerCase().includes(filterValue)
    //   );
    // }
  }

  calculateColumnSum(column: string): number {
    return this.salesQuotationLines.controls.reduce((acc, control,index) => {
      //// // debugger;
      const value = this.getFormattedNumber(index,column);
      return acc + (value ? +value : 0); // Convert value to number and add to sum
    }, 0);
  }
}
